import { render, staticRenderFns } from "./PromotionsAndDiscounts.vue?vue&type=template&id=3e5966f8&scoped=true&"
import script from "./PromotionsAndDiscounts.vue?vue&type=script&lang=js&"
export * from "./PromotionsAndDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsAndDiscounts.vue?vue&type=style&index=0&id=3e5966f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5966f8",
  null
  
)

export default component.exports